import React, { useState, useEffect } from 'react';
import './Dashboard.css';
import ThemeToggle from './ThemeToggle';
import caLogo from '../images/logo.png';

// Icons
import { Database, Shuffle, Activity, ArrowLeft, Book } from 'lucide-react';

// Sections
import ConnectionsSection from './sections/ConnectionsSection';
import MigrationsSection from './sections/MigrationsSection';
import MonitorSection from './sections/MonitorSection';


function Dashboard({
  apiUrl,
  onBackToHome,
  activeSection,
  setActiveSection,
  connections,
  jobs,
  loading,
  setLoading,
  showNotification,
  onRefreshConnections,
  onRefreshJobs,
  theme,
  toggleTheme
}) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  useEffect(() => {
    onRefreshConnections();
    onRefreshJobs();
    const interval = setInterval(() => {
      onRefreshConnections();
      onRefreshJobs();
    }, 10000); // Refresh every 10 seconds
    return () => clearInterval(interval);
  }, [onRefreshConnections, onRefreshJobs]);

  const sections = [
    { id: 'connections', label: 'Connections', icon: <Database size={20} /> },
    { id: 'migrations', label: 'Migrations', icon: <Shuffle size={20} /> },
    { id: 'monitor', label: 'Monitor', icon: <Activity size={20} /> }
  ];

  const renderSection = () => {
    const commonProps = {
      apiUrl,
      connections,
      jobs,
      onRefresh: () => {
        onRefreshConnections();
        onRefreshJobs();
      },
      loading,
      setLoading,
      showNotification
    };

    switch (activeSection) {
      case 'connections':
        return <ConnectionsSection {...commonProps} />;
      case 'migrations':
        return <MigrationsSection {...commonProps} />;
      case 'monitor':
        return <MonitorSection {...commonProps} />;
      default:
        return <ConnectionsSection {...commonProps} />;
    }
  };

  return (
    <div className="dashboard">
      {/* Header */}
      <header className="dashboard-header">
        <div className="header-left">
          <button onClick={onBackToHome} title="Back" style={{ background: 'transparent', border: 'none', color: 'var(--text-main)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 10px 0 0', opacity: 0.7, transition: 'opacity 0.2s' }} onMouseEnter={(e) => e.currentTarget.style.opacity = '1'} onMouseLeave={(e) => e.currentTarget.style.opacity = '0.7'}>
            <ArrowLeft size={20} />
          </button>
          <button
            className="sidebar-toggle"
            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
            title={sidebarCollapsed ? "Expand Sidebar" : "Collapse Sidebar"}
          >
            ☰
          </button>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <img src={caLogo} alt="Cloud Ambassadors" style={{ height: '28px', objectFit: 'contain' }} />
            <h1>Data Lift</h1>
          </div>
        </div>
        <div className="header-right">
          <ThemeToggle theme={theme} toggleTheme={toggleTheme} />
          <button className="btn-secondary" onClick={() => window.open('https://docs.dmsplatform.io', '_blank')} title="View Documentation">
            <Book size={16} />
            Documentation
          </button>
        </div>
      </header>

      {/* Main Content */}
      <div className="dashboard-body">
        {/* Sidebar */}
        <aside className={`dashboard-sidebar ${sidebarCollapsed ? 'collapsed' : ''}`}>
          <nav className="sidebar-nav">
            {sections.map(section => (
              <div
                key={section.id}
                className={`nav-item ${activeSection === section.id ? 'active' : ''}`}
                onClick={() => setActiveSection(section.id)}
                title={sidebarCollapsed ? section.label : ""}
              >
                <div className={`nav-icon ${section.id}-icon`}>{section.icon}</div>
                <div className="nav-label">{section.label}</div>
              </div>
            ))}
          </nav>
        </aside>

        {/* Main Content Area */}
        <main className="dashboard-main">
          {/* Active Section Content */}
          {renderSection()}
        </main>
      </div>


    </div>
  );
}

export default Dashboard;